import React, { useState } from 'react';
import { Button, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PasswordEdit, { PasswordEditFormData } from '../popups/passwordEdit/PasswordEdit';
import './PasswordSection.scss';
import editIcon from 'assets/images/edit.png';
import { updateProfile } from 'services/profileService';
import { MemberProfile } from 'types/dto/profile';
import { UpdateProfileDTO } from 'types/dto/order';
import { buildPasswordChangeSuccessPath } from 'utils/pathBuilder';

interface PasswordSectionProps {
  profile?: MemberProfile;
}

const PasswordSection: React.FC<PasswordSectionProps> = ({ profile }) => {
  const { t } = useTranslation('profile');
  const navigate = useNavigate();
  const { t: tCommon } = useTranslation('common');

  // State for drawer visibility
  const [isPasswordEditVisible, setIsPasswordEditVisible] = useState(false);

  const handleChangePassword = () => {
    setIsPasswordEditVisible(true);
  };

  const handlePasswordEditClose = () => {
    setIsPasswordEditVisible(false);
  };

  const handlePasswordEditSave = async (data: PasswordEditFormData) => {
    if (!profile?.loyalty_account) return;

    try {
      const dto: UpdateProfileDTO = {
        juicyAppUniqueId: profile.loyalty_account.unique_id || '',
        loyaltyAccount: {
          ...profile.loyalty_account,
          new_password: data.newPassword,
        },
      };

      await updateProfile('/profile', dto);

      message.success(tCommon('message.saveSuccess'), 1.5).then(() => {
        setIsPasswordEditVisible(false);
        navigate(buildPasswordChangeSuccessPath());
      });

    } catch (error) {
      console.error('Password update failed:', error);
      message.error(tCommon('message.saveFailed'));
    }
  };

  return (
    <>
      {/* Change Password Section */}
      <div className="password-section">
        <div className="password-header">
          <div className="section-title">{t('security.title')}</div>
          <Button
            type="link"
            icon={<img src={editIcon} className='edit-icon'/>}
            onClick={handleChangePassword}
            className="change-button desktop-button"
          >
            {t('security.change')}
          </Button>
        </div>
        <div className="password-description">
          {t('security.description')}
        </div>
        {/* Mobile button - appears below content on mobile */}
        <div>
          <Button
            type="link"
            icon={<img src={editIcon} className='edit-icon'/>}
            onClick={handleChangePassword}
            className="change-button mobile-button"
          >
            {t('security.change')}
          </Button>
        </div>
      </div>

      {/* Password Edit Drawer */}
      <PasswordEdit
        visible={isPasswordEditVisible}
        onClose={handlePasswordEditClose}
        onSave={handlePasswordEditSave}
      />
    </>
  );
};

export default PasswordSection;
